const ATTRIBUTION_SUFFIX = /\s*\[(?<name>[^\]]*) copy(?: (?<counter>\d+))?\]$/;

/**
 * Title for a document copy, attributed to the user who copies it:
 * "Title" becomes "Title [User Name copy]". An existing attribution suffix is
 * replaced; when the same user copies their own copy, a counter is appended
 * ("Title [User Name copy 1]", "Title [User Name copy 2]", ...).
 */
export function attributedCopyTitle(title: string, userName: string): string {
  const match = title.match(ATTRIBUTION_SUFFIX);
  const base = match ? title.slice(0, match.index) : title;

  const suffix =
    match?.groups?.name === userName
      ? `${userName} copy ${Number(match.groups?.counter ?? 0) + 1}`
      : `${userName} copy`;

  return `${base} [${suffix}]`.trimStart();
}
